// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3252159a","239":"837ae7ea","264":"7f5222ba","389":"2823926d","433":"6e500a9f","453":"796045e0","455":"16214342","508":"004531f8","582":"70d5ea6a"}[chunkId] + ".chunk.js";
};